import React, { Component } from "react";
import "./CurrentlyCharging.css";
import Table from "../Table/index";
import { getReportDownload } from "../JSONCSV";
import moment from "moment"
import EmptyState from "../../../../../../../assets/svg/evNoData.svg";
import carBattery from "../../../../../../../assets/images/carbat.svg"
class CurrentlyCharging extends Component {
  constructor(props) {
    super(props);
    this.state = {
      viewIdx: 0,
    };
  }
  getCSVName(){
    let auth=window.auth
    let date=moment().format("DD-MM-YYYY_Hmm")
    return auth.userinfo.username+"_Currently_Charging_"+date
  }
  getLastUpdated(data){
   let last= Math.max.apply(Math, data.map(function(charge) { return charge.starttime; }))
   let findLast=(last+1800000)-((last+1800000)%1800000)
    return moment(findLast).format("DD MMM YYYY, h:mm A")
  }

  searchReport(key){
    var filter, table, tr, td, i, txtValue;
    filter = key.toUpperCase();
    table = document.getElementById("chargingTable");
    tr = table.getElementsByTagName("tr");
    for (i = 0; i < tr.length; i++) {
      td = tr[i].getElementsByTagName("td")[0];
      if (td) {
        txtValue = td.textContent || td.innerText;
        if (txtValue.toUpperCase().indexOf(filter) > -1) {
          tr[i].style.display = "";
        } else {
          tr[i].style.display = "none";
        }
      }       
    }
    }


  render() {
    return (
      <div
      className={"CurrentlyCharging "+ (this.props.isExpanded==="ct002" ?"expandedWidget ":"" )}


       style={{opacity:this.props.isLive?1:'0.1'}}>
        <div className="header">
          <div>Currently Charging</div>
          <div
            className="rightIcons"
            style={{
              display: "flex",
              justifyContent: "space-between",
              width: 50,
              alignItems: "center",
            }}
          >
             <i
            onClick={() =>
              getReportDownload(
                this.props.data.history,
                this.props.heads,
                this.getCSVName()
              )
            }
            className="fa fa-download"
          ></i>
            {this.props.isExpanded == "ct002" ? (
              <i  onClick={()=>this.props.setExpand("ct002")} className="fa fa-window-minimize"></i>
            ) : (
              <i onClick={()=>this.props.setExpand("ct002")} className="fa fa-window-maximize"></i>
            )}
          </div>
      
        </div>
        {this.props.data.distribution > 0 ? (
               <div
               style={{
                 display: "flex",
                 justifyContent: this.state.viewIdx===1?"space-between":'flex-end',
                 alignItems: "center",
               }}
             >
               {this.state.viewIdx === 1 ? (
                 <div
                   className="searchBox"
                   style={{ marginLeft: 12, marginTop: 9, width:this.props.isExpanded == "ct002" ?295:150}}
                   >
                   <input
                     type="text"
                     placeholder="search"
                     style={{
                      padding: "3px 8px",
                    borderRadius: 15,
                    width: "100%",
                    border: "1px solid #b1b1b1",
                    fontSize:11,
                    color:'#4c4a4a'
                     }}
                     onChange={(e)=>this.searchReport(e.target.value)}
                   />
                 </div>
               ) : null}

          <div className="topAction" style={{justifyContent:'space-between',width:this.state.viewIdx===0?"100%":"inherit"}}> 
          {this.state.viewIdx === 0 ? (

            <div>
              <small style={{fontSize:10,fontStyle:'italic'}}>* Last updated at {this.getLastUpdated(this.props.data.history)}</small>
              </div>):null}
            <ul>
              <li
                onClick={() => this.setState({ viewIdx: 0 })}
                className={this.state.viewIdx === 0 ? "active" : ""}
              >
                Chart
              </li>
              <li
                onClick={() => this.setState({ viewIdx: 1 })}
                className={this.state.viewIdx === 1 ? "active" : ""}
              >
                Table
              </li>
            </ul>
          </div>
          </div>
        ) : null}
        {this.state.viewIdx === 0 ? (
          <div className="widgetbody">
            <div
              id="pieEV"
              ref="currentlycharging"
              className="chargeBody"
            >
            {this.props.isLive?
              // <div className="charging-container">
              //   <div className="chargestat">
              //     <i className="fa fa-bolt"></i>
              //     <div className="vehCount">{this.props.data.distribution}</div>
              //   </div>
              // </div>font-size: 4rem;
              <div style={{display:'flex'}}>
              <i className="fas fa-plug" style={{fontSize:this.props.isExpanded == "ct002"?'7rem':'4rem',color:"#5bcc5b"}}></i>
               <div className="vehCount" style={{fontSize:this.props.isExpanded == "ct002"?'7rem':'4rem'}}>{this.props.data.distribution}</div>
              </div>

            :
            <div className="additionCount" style={{fontSize:60}}>{this.props.data.distribution}</div>
            }
          </div>
          </div>
        ) : (
          <div className="tableView">
            <Table
              updateData={this.props.updateData}
              ref={(ref) => {
                this.child = ref;
              }}
              data={this.props.data.history}
              heads={this.props.heads}
              metric="currentcharging"
              colorOn="soc"
              tableId="chargingTable"
            />
          </div>
        )}
      </div>
    );
  }
}

export default CurrentlyCharging;
